import { ENV } from '@/lib/config';

/**
 * The headers an agent stream sends: the request's own, the local test token when local testing
 * authentication is on, and the selected workspace.
 */
export function agentStreamHeaders(
  headers: HeadersInit | undefined,
  workspaceId: string,
): Record<string, string> {
  const plain: Record<string, string> =
    headers instanceof Headers
      ? Object.fromEntries(headers.entries())
      : Array.isArray(headers)
        ? Object.fromEntries(headers)
        : { ...headers };
  if (ENV.ENABLE_LOCAL_TESTING_AUTHENTICATION && ENV.LOCAL_TOKEN) {
    plain.Authorization = ENV.LOCAL_TOKEN;
  }
  return { ...plain, 'x-selected-workspace-id': workspaceId };
}
